<template>
    <div ref="myGridDetailsCrud" :crudtitle="crudtitle">
        <JqxGrid ref="myGridDetails" :theme="'material'"
                 :width="'100%'" :columnsresize="true"
                 :editable="true" :sortable="true" :altrows="true"
                 :showtoolbar="true" :rendertoolbar="rendertoolbar"
                 :autoheight="true" :pageable="true" :pagermode="'default'"
                 :pagesizeoptions=" ['10', '20', '30', '100'] " :pagesize="20"
                 :groupable="true" :showfilterrow="true"
                 :filterable="true" :autoshowfiltericon="true"
                 @cellendedit="onCellendedit($event)" @cellbeginedit="onCellebeginedit($event)"
                 :handlekeyboardnavigation="handlekeyboardnavigation" :selectionmode="'singlecell'"
                 :editmode="'dblclick'" @cellvaluechanged="onCellValueChanged($event)"
        >
        </JqxGrid>
    </div>
</template>

<script>
    //Declare standard import comonent
    import JqxGrid from "~jqx/jqwidgets-vue/vue_jqxgrid.vue";
    import {mapGetters} from 'vuex';
    // Declare axios
    const axios = require('axios');
    //Declare global reference JS
    let colonnegenerali = {};
    let table;
    let lastid = null;
    let fieldnotallowed = null;
    let alldata = null;
    let newrow = false;
    let source;
    let listarticoli = [];
    let listdescrizioni = [];
    let listubicazioni = [];
    let listlotti = [];
    let listpezzicolli = [];
    let globalarticoloindex = "";

    export default {
        name: "JqxDetailsIngressiUscite",
        components: {
            JqxGrid,

        },
        props: {
            crudtitle: {type: String, default: 'Gestione ingressi'},
        },
        data: function () {
            return {
                theme: "theme",
                crudmodel: {type: String},
                impianto: {type: Number},
                stato: {type: String},
                rows: [],
                articoli: [],
                descrizioni: [],
                ubicazioni: [],
                riga_modifica: 0,
            }
        },
        computed: mapGetters({
            user: 'auth/user',
            //position: 'position/pos'
        }),
        mounted: function () {
            source = {
                datatype: 'json',
                id: 'id',
                url: this.crudmodel,
                processdata: function (data) {
                    data.featureClass = "P";
                    data.style = "full";
                    data.maxRows = 50;
                },
            };
            table = this.crudmodel;
            this.createbuttons();
            //this.dataCreationCustom();
        },
        methods: {
            onCellebeginedit: function(event){
                this.riga_modifica = event.args.rowindex;
            },
            onCellendedit: function (event) {
                try {
                    // if (event.args.datafield == "ubicazione_id" && event.args.owner.editEvent.keyCode == 9) {
                    //   document.getElementById("buttonContainer4").click();
                    //   this.$refs.myGridDetails.selectcell(1, 'articolo');
                    // }
                    if (event.args.datafield == "quantita_dichiarata" && event.args.owner.editEvent.keyCode == 9) {
                        this.$refs.myGridDetails.selectcell(event.args.row.uid, 'lotto_id');
                    }
                    if(event.args.datafield == "articolo_id"){
                        let component = this;
                        let args = event.args;
                        if (args && args.value) {
                            let value = args.value.value;
                            let url = `/api/getdata/articolo`;
                            axios.get(url, {
                                params: {
                                    id: value
                                }
                            }).then((data) => {
                                if (data && data.data.length > 0) {
                                    let rowId = this.riga_modifica;
                                    // let rowId = component.$refs.myGridDetails.getselectedcell().rowindex;

                                    component.$refs.myGridDetails.setcellvalue(rowId, 'descrizione_articolo_id', String(data.data[0].id));
                                    component.$refs.myGridDetails.setcellvalue(rowId, 'descrizione_articolo', String(data.data[0].descrizione_articolo));
                                    component.$refs.myGridDetails.setcellvalue(rowId, 'unita_di_misura', String(data.data[0].unita_di_misura));
                                    component.$refs.myGridDetails.setcellvalue(rowId, 'lotto', '');
                                }
                            });
                        }
                    }
                    if(event.args.datafield == "descrizione_articolo_id"){
                        let component = this;
                        let args = event.args;
                        if (args && args.value) {
                            let value = args.value.value;
                            let url = `/api/getdata/articolo`;

                            axios.get(url, {
                                params: {
                                    id: value
                                }
                            }).then((data) => {
                                if (data && data.data.length > 0) {
                                    let rowId = this.riga_modifica;
                                    // let rowId = component.$refs.myGridDetails.getselectedcell().rowindex;

                                    component.$refs.myGridDetails.setcellvalue(rowId, 'articolo_id', String(data.data[0].id));
                                    component.$refs.myGridDetails.setcellvalue(rowId, 'articolo', String(data.data[0].articolo));
                                    component.$refs.myGridDetails.setcellvalue(rowId, 'unita_di_misura', String(data.data[0].unita_di_misura));
                                    component.$refs.myGridDetails.setcellvalue(rowId, 'lotto', '');
                                }
                            });
                        }
                    }
                    //Gestione dinamica quantità e disponibilità articoli a magazzino per gestione uscite corpo
                    /*if (this.crudmodel.indexOf("GestioneUsciteCorpo") !== -1 && event.args.datafield === "quantita_dichiarata") {
                        let rowID = this.$refs.myGridDetails.getrowid(event.args.row.boundindex);
                        let rowBoundIndex = event.args.row.boundindex;
                        let articolo_value = this.$refs.myGridDetails.getcelltext(rowBoundIndex, 'articolo_id');
                        let lotto_value = this.$refs.myGridDetails.getcelltext(rowBoundIndex, 'lotto_id');
                        let quantita_caricata_value = this.$refs.myGridDetails.getcelltext(rowBoundIndex, 'quantita_caricata');
                        let url = `/api/check/availability/article`;
                        axios.get(url, {
                            params: {
                                articoloid: articolo_value,
                                lottovalue: lotto_value,
                                quantita_caricata: quantita_caricata_value
                            }
                        }).then((data) => {
                            if (!data.data) {
                                alert('Attenzione mancanza di disponibilità a magazzino');
                            }
                        });
                    }*/
                } catch (e) {

                }


                // if (event.args.datafield == "articolo_id") {
                //   let rowID = this.$refs.myGridDetails.getrowid(event.args.row.boundindex);
                //   let row = this.$refs.myGridDetails.getrowdatabyid(rowID);
                //   this.$refs.myGridDetails.setcellvalue(event.args.row.boundindex, 'descrizione_articolo', String(globalarticoloindex));
                //
                // }
            },
            onCellValueChanged: function (event) {
                if (this.crudmodel.indexOf("GestioneUsciteCorpo") !== -1 && event.args.datafield == "quantita_caricata") {
                    this.checkAvailability();
                }
                // this.checkAvailability();
            },
            reorderColum: function () {
                // Imposto ordine colonne da front-end
                // try {
                //     this.$refs.myGridDetails.setcolumnindex('articolo', 0);
                //     this.$refs.myGridDetails.setcolumnindex('descrizione_articolo_id', 1);
                //     // this.$refs.myGridDetails.setcolumnindex('quantita_dichiarata', 5);
                // } catch (e) {
                //
                // }

            },
            rendertoolbar: function (toolbar) {
                let container = document.createElement('div');
                container.id = 'containerToolbarDetails';
                container.style.margin = '5px';
                let buttonContainer1 = document.createElement('div');
                buttonContainer1.id = 'buttonContainer4';
                buttonContainer1.style.cssText = 'float: left; margin-right:5px;';
                container.appendChild(buttonContainer1);
                let buttonContainer2 = document.createElement('div');
                buttonContainer2.id = 'buttonContainer5';
                buttonContainer2.style.cssText = 'float: left';
                container.appendChild(buttonContainer2);
                let buttonContainer3 = document.createElement('div');
                buttonContainer3.id = 'buttonContainer6';
                buttonContainer3.style.cssText = 'float: left';
                container.appendChild(buttonContainer3);
                toolbar[0].appendChild(container);
            },
            createbuttons: function () {
                let addRowButton = jqwidgets.createInstance('#buttonContainer4', 'jqxButton', {
                    width: 120,
                    value: 'Inserisci nuovo',
                    theme: 'material'
                });
                addRowButton.addEventHandler('click', (row) => {
                    this.endEdit();
                    if (lastid != null) {
                        lastid = parseInt(lastid) + 1;
                    } else {
                        lastid = 0;
                    }

                    try {
                        if (this.stato != "da_completare" && this.stato != "merce_in_arrivo" && this.stato != "prelievo_inserito" && this.stato != null && this.stato != undefined && this.stato != '') {
                            alert("Attenzione! non è possibile apportare modifiche a questo servivizio per via del suo stato!");
                        } else {
                            this.$refs.myGridDetails.addrow(lastid, {});
                        }
                    } catch (err) {

                    }
                    // this.$refs.myGridDetails.selectcell(lastid,'articolo_id');
                    // this.$refs.myGridDetails.begincelledit(lastid,'articolo_id');
                    newrow = true;
                    // this.reorderColum();
                });


                let exportData = jqwidgets.createInstance('#buttonContainer5', 'jqxButton', {
                    width: 120,
                    value: 'Esporta in Excel',
                    theme: 'material'
                });
                exportData.addEventHandler('click', (row) => {
                    this.endEdit();
                    this.$refs.myGridDetails.exportdata('xls', 'jqxGrid');
                });

                let clearFilter = jqwidgets.createInstance('#buttonContainer6', 'jqxButton', {
                    width: 120,
                    value: 'Rimuovi filtri',
                    theme: 'material'
                });
                clearFilter.addEventHandler('click', (row) => {
                    this.endEdit();
                    this.$refs.myGridDetails.clearfilters();
                });
            },
            pagerrenderer: function () {
                //this.$refs.myGridDetails.autoresizecolumns();
            },
            buildAccessoryColumnsCustom: function (data) {
                let b;

                b = {
                    text: 'Delete', datafield: 'Delete', columntype: 'button', width: '50',
                    cellsrenderer: (index, datafield, value, defaultvalue, column, rowdata) => {
                        return 'Delete';
                    },
                    buttonclick: (row) => {
                        this.deleteButtonCustomDetails(row);
                    }
                };
                let h = {
                    text: 'Clone', datafield: 'Clone', columntype: 'button', width: '50',
                    cellsrenderer: () => {
                        return 'Clone';
                    },
                    buttonclick: (row) => {
                        this.cloneButtonCustomDetails(row);
                    }
                };

                let c = [];
                c.push(h);
                c.push(b);
                return c;
            },
            dataCreationCustomDetails: function () {
                if (typeof (this.articoli.length) === undefined) {
                    let rows = this.rows[this.impianto];
                    let gridAdapter = new jqx.dataAdapter({
                        id: 'id',
                        localdata: rows,
                    });
                    this.$refs.myGridDetails.hideloadelement();
                    this.$refs.myGridDetails.beginupdate();
                    this.$refs.myGridDetails.setOptions
                    ({
                        source: gridAdapter,
                    });
                    this.$refs.myGridDetails.endupdate();
                    listarticoli = this.articoli[this.impianto];
                    listdescrizioni = this.descrizioni[this.impianto];
                    listubicazioni = this.ubicazioni[this.impianto];
                } else {
                    source = {
                        datatype: 'json',
                        id: 'id',
                        url: this.crudmodel,
                        processdata: function (data) {
                            data.featureClass = "P";
                            data.style = "full";
                            data.maxRows = 50;
                        },
                    };
                    table = this.crudmodel;
                    const dataAdapter = new jqx.dataAdapter(source, {
                            autoBind: true,
                            downloadComplete: (data) => {
                                ///MOD PA
                                this.articoli = data[6];
                                this.descrizioni = data[5];
                                this.ubicazioni = data[7];
                                listarticoli = this.articoli[this.impianto];
                                listdescrizioni = this.descrizioni[this.impianto];
                                listubicazioni = this.ubicazioni[this.impianto];
                                listlotti = data[8];
                                listpezzicolli = data[9];

                                const descrizioneArticoliSource = {
                                    datatype: 'array',
                                    datafields: [
                                        {name: 'descrizione_articolo', type: 'string'},
                                        {name: 'descrizione_articolo_id', type: 'string'}
                                    ],
                                    localdata: listdescrizioni
                                };
                                this.descrizioneArticoliAdapter = new jqx.dataAdapter(descrizioneArticoliSource, {autoBind: true});
                                const articoliSource = {
                                    datatype: 'array',
                                    datafields: [
                                        {name: 'articolo', type: 'string'},
                                        {name: 'articolo_id', type: 'string'}
                                    ],
                                    localdata: listarticoli
                                };
                                this.articoliAdapter = new jqx.dataAdapter(articoliSource, {autoBind: true});
                                ///
                                let columns = data[0].columns;
                                let accessoryColumns = this.buildAccessoryColumnsCustom(data);
                                columns.push(
                                    accessoryColumns[0],
                                    accessoryColumns[1],
                                );
                                // columns[0].displayfield = 'articolo_combobox';
                                columns[0].displayfield = 'articolo';
                                columns[0].createeditor = (row, column, editor) => {
                                    editor.jqxComboBox({
                                        dropDownHeight: 250,
                                        source: this.articoliAdapter,
                                        autoComplete: true,
                                        displayMember: 'articolo',
                                        valueMember: 'articolo_id'
                                    });
                                };
                                columns[0].cellvaluechanging = (row, column, columntype, oldvalue, newvalue) => {
                                  console.log('PIPPO');
                                    if (this.crudmodel.indexOf("GestioneUsciteCorpo") !== -1 && newvalue != '' && oldvalue != newvalue.value) {
                                        this.checkAvailability(newvalue.value, '', '');
                                    }
                                    // return the old value, if the new value is empty.
                                    if (newvalue == '') return oldvalue;
                                };
                                // columns[1].displayfield = 'descrizione_articolo_combobox';
                                columns[1].displayfield = 'descrizione_articolo';
                                columns[1].createeditor = (row, column, editor) => {
                                    editor.jqxComboBox({
                                        dropDownHeight: 250,
                                        // autoDropDownHeight: true,
                                        searchMode: 'containsignorecase',
                                        source: this.descrizioneArticoliAdapter,
                                        // promptText: 'Please Choose:',
                                        autoComplete: true,
                                        displayMember: 'descrizione_articolo',
                                        valueMember: 'descrizione_articolo_id'
                                    });
                                };
                                columns[1].cellvaluechanging = (row, column, columntype, oldvalue, newvalue) => {
                                    if (this.crudmodel.indexOf("GestioneUsciteCorpo") !== -1 && newvalue != '' && oldvalue != newvalue.value) {
                                        this.checkAvailability(newvalue.value,  '', '');
                                    }
                                    // return the old value, if the new value is empty.
                                    if (newvalue == '') return oldvalue;
                                };
                                /*columns[6].displayfield = 'ubicazione';
                                columns[6].createeditor = (row, column, editor) => {
                                    // assign a new data source to the combobox.
                                    let component = this;

                                    editor.jqxComboBox({
                                        // dropDownHeight: 250,
                                        // autoDropDownHeight: true,
                                        source: this.ubicazioniAdapter,
                                        // promptText: 'Please Choose:',
                                        // autoComplete: true,
                                        displayMember: 'ubicazione',
                                        valueMember: 'ubicazione_id'
                                    });
                                };
                                columns[6].cellvaluechanging = (row, column, columntype, oldvalue, newvalue) => {
                                    // return the old value, if the new value is empty.
                                    if (newvalue == '') return oldvalue;
                                };*/
                                if (this.crudmodel.indexOf("GestioneUsciteCorpo") !== -1) {
                                    // columns.push(
                                    //     accessoryColumns[0],
                                    //     accessoryColumns[1],
                                    //     accessoryColumns[2],
                                    //     accessoryColumns[3],
                                    //     accessoryColumns[4],
                                    //     accessoryColumns[5]
                                    //     // this.buildAccessoryColumnsCustom(data)[0],
                                    //     // this.buildAccessoryColumnsCustom(data)[1],
                                    //     // this.buildAccessoryColumnsCustom(data)[2],
                                    //     // this.buildAccessoryColumnsCustom(data)[3],
                                    //     // this.buildAccessoryColumnsCustom(data)[4]
                                    // );
                                    columns[4].displayfield = 'lotto';
                                    columns[4].initeditor = (row, column, editor) => {
                                      let articolo_id = this.$refs.myGridDetails.getcellvalue(row, 'articolo_id');
                                      let pezzi_collo = this.$refs.myGridDetails.getcellvalue(row, 'pezzi_collo');
                                      let lotto = editor.val();
                                      let lotti = new Array();
                                      //PA foreach listlotti popola le casistiche
                                      for (let key in listlotti) {
                                          // skip loop if the property is from prototype
                                          if (!listlotti.hasOwnProperty(key)) continue;
                                          if((pezzi_collo == null || pezzi_collo == '') && key.startsWith(articolo_id + '|||')){
                                            lotti = lotti.concat(listlotti[key].filter(item => lotti.indexOf(item) < 0))
                                          } else if (key == articolo_id + '|||' + pezzi_collo) {
                                            lotti = listlotti[key];
                                          }
                                      }
                                      editor.jqxComboBox({
                                          autoDropDownHeight: true,
                                          searchMode: 'containsignorecase',
                                          source: lotti,
                                          promptText: '',
                                          autoComplete: true,
                                      });
                                      // editor.on("select", ()=>{
                                      //     this.checkAvailability();
                                      // });
                                    };
                                    columns[4].cellvaluechanging = (row, column, columntype, oldvalue, newvalue) => {
                                        if (this.crudmodel.indexOf("GestioneUsciteCorpo") !== -1 && oldvalue != newvalue ) {
                                            this.checkAvailability(false, newvalue, false);
                                        }
                                        // return the old value, if the new value is empty.
                                        // if (newvalue == '') return oldvalue;
                                    };

                                  columns[6].displayfield = 'pezzi_collo';
                                  columns[6].initeditor = (row, column, editor) => {
                                    let articolo_id = this.$refs.myGridDetails.getcellvalue(row, 'articolo_id');
                                    let lotto = this.$refs.myGridDetails.getcellvalue(row, 'lotto');
                                    let pezzi_collo = new Array();
                                    //PA foreach listlotti popola le casistiche
                                    for (let key in listpezzicolli) {
                                      // skip loop if the property is from prototype
                                      if (!listpezzicolli.hasOwnProperty(key)) continue;

                                      if((lotto == null || lotto == '') && key.startsWith(articolo_id + '|||')){
                                        pezzi_collo = pezzi_collo.concat(listpezzicolli[key].filter(item => pezzi_collo.indexOf(item) < 0))
                                      } else if (key == articolo_id + '|||' + lotto) {
                                        pezzi_collo = listpezzicolli[key];
                                      }
                                    }
                                    pezzi_collo = pezzi_collo.map(x => x.toString());
                                    editor.jqxComboBox({
                                      autoDropDownHeight: true,
                                      searchMode: 'containsignorecase',
                                      source: pezzi_collo,
                                      promptText: '',
                                      autoComplete: true,
                                    });
                                    // editor.on("select", ()=>{
                                    //     this.checkAvailability();
                                    // });
                                  };
                                  columns[6].cellvaluechanging = (row, column, columntype, oldvalue, newvalue) => {
                                    if (this.crudmodel.indexOf("GestioneUsciteCorpo") !== -1 && oldvalue != newvalue ) {
                                      this.checkAvailability(false, false, newvalue);
                                    }
                                    // return the old value, if the new value is empty.
                                    // if (newvalue == '') return oldvalue;
                                  };

                                } else {
                                  columns[5].createeditor = (row, column, editor) => {
                                    editor.jqxNumberInput({ decimalDigits: 1, digits: 3 });
                                  };
                                  columns[6].createeditor = (row, column, editor) => {
                                    editor.jqxNumberInput({ decimalDigits: 0, digits: 8 });
                                  };

                                  // columns.push(
                                    //     accessoryColumns[0],
                                    //     accessoryColumns[1],
                                    //     accessoryColumns[2],
                                    //     accessoryColumns[3],
                                    //     accessoryColumns[4]
                                    // );
                                }
                                if (!this.rows.length) {
                                    this.rows[this.impianto] = data[1].rows;
                                }
                                let rows = this.rows[this.impianto];
                                let datafields = data[2].datafields;
                                datafields[this.crudmodel.indexOf("GestioneUsciteCorpo") === -1 ? 11 : 10].values = {
                                    source: this.articoliAdapter.records,
                                    value: 'articolo_id',
                                    name: 'articolo'
                                };
                                datafields[this.crudmodel.indexOf("GestioneUsciteCorpo") === -1 ? 12 : 11].values = {
                                    source: this.descrizioneArticoliAdapter.records,
                                    value: 'descrizione_articolo_id',
                                    name: 'descrizione_articolo'
                                };
                                let maxid = data[3];
                                // rows = [
                                //     {articolo_id: 3, descrizione_articolo_id: 3},
                                //     {articolo_id: 1, descrizione_articolo_id: 1},
                                //     ];
                                let gridAdapter = new jqx.dataAdapter({
                                    datafields: datafields,
                                    id: 'id',
                                    localdata: rows,
                                });
                                this.$refs.myGridDetails.hideloadelement();
                                this.$refs.myGridDetails.beginupdate();
                                this.$refs.myGridDetails.setOptions
                                ({
                                    source: gridAdapter,
                                    columns: columns,
                                });
                                this.$refs.myGridDetails.endupdate();
                                colonnegenerali = columns;
                                lastid = maxid;
                                fieldnotallowed = data[4];
                                alldata = data;
                                // try {
                                //     // this.$refs.myGridDetails.setcolumnindex('articolo', 0);
                                //     // this.$refs.myGridDetails.setcolumnindex('descrizione_articolo_id', 1);
                                //     // if (this.crudmodel.indexOf("GestioneUsciteCorpo") !== -1) {
                                //     //     this.$refs.myGridDetails.setcolumnindex('quantita_dichiarata', 5);
                                //     // }
                                // } catch (err) {
                                //
                                // }
                            }
                        }
                    );
                }

            },

            articoloOnSelect: function (event) {
            },

            setQueryModel(data) {
                this.crudmodel = data;
                //this.dataCreationCustomDetails();
            },
            setStato(data) {
                this.stato = data;
            },
            setImpianto(data) {
                this.impianto = data;
                //this.dataCreationCustomDetails();
            },
            resetGrid() {
                this.rows = [];
                this.articoli = [];
                this.descrizioni = [];
                this.ubicazioni = [];

            },

            checkAvailability: function (articolo_value = false, lotto_value = false, pezzi_collo_value = false) {
                // let cell = this.$refs.myGridDetails.getselectedcell();
                // let rowBoundIndex = cell.rowindex;
                let rowBoundIndex = this.riga_modifica;
                articolo_value = articolo_value ? articolo_value : this.$refs.myGridDetails.getcelltext(rowBoundIndex, 'articolo_id');
                lotto_value = lotto_value ? lotto_value : this.$refs.myGridDetails.getcelltext(rowBoundIndex, 'lotto');
                pezzi_collo_value = pezzi_collo_value ? pezzi_collo_value : this.$refs.myGridDetails.getcelltext(rowBoundIndex, 'pezzi_collo');
                let quantita_caricata_value = this.$refs.myGridDetails.getcelltext(rowBoundIndex, 'quantita_caricata');
                let url = `/api/check/availability/article`;
                if(!articolo_value || !quantita_caricata_value){
                   return;
                }
                axios.get(url, {
                    params: {
                        articoloid: articolo_value,
                        lottovalue: lotto_value,
                        pezzi_collo: pezzi_collo_value,
                        quantita_caricata: quantita_caricata_value
                    }
                }).then((data) => {
                    if (data.data !== true) {
                        alert('Attenzione mancanza di disponibilità a magazzino. La quantità disponibile è: ' + data.data);
                        this.$refs.myGridDetails.setcellvalue(rowBoundIndex, 'quantita_caricata', data.data);
                    }
                });
            },

            getvalori() {
                return this.$refs.myGridDetails.getrows();
            },
            deleteButtonCustomDetails: function (row) {
                //get the data and append in to the inputs
                let rowdata = this.$refs.myGridDetails.getrowdata(row);
                if (this.crudmodel.indexOf("GestioneUsciteCorpo") === -1 && rowdata.quantita_caricata) {
                    alert("Attenzione! non è possibile eliminare una riga dove la voce \"Quantita Caricata\" è valorizzata!");
                } else if (confirm('Sicuro? Proseguo con l\'eliminazione?')) {
                    this.deleterowdetails = row;
                    let rowID = this.$refs.myGridDetails.getrowid(this.deleterowdetails);
                    this.$refs.myGridDetails.deleterow(rowID);
                }
            },
            cloneButtonCustomDetails: function (row) {
                //clone row
                this.clonerowdetails = row;
                let rowID = this.$refs.myGridDetails.getrowid(this.clonerowdetails);
                let data = this.$refs.myGridDetails.getrowdatabyid(rowID);
                let clonerow = {};
                for (let r = 0; r < alldata[0].columns.length; r++) {
                    let colonne = alldata[0].columns[r].datafield;
                    if (fieldnotallowed.includes(colonne)) {
                        continue;
                    }
                    clonerow[colonne] = data[colonne];
                }
                clonerow.descrizione_articolo = data.descrizione_articolo;
                clonerow.articolo = data.articolo;
                clonerow.ubicazione = data.ubicazione;
                clonerow.udc = null;
                this.$refs.myGridDetails.addrow(rowID + 1, clonerow, rowID + 1);
            },
            handlekeyboardnavigation: function (event) {
                let key = event.charCode ? event.charCode : event.keyCode ? event.keyCode : 0;
                let cell = this.$refs.myGridDetails.getselectedcell();
                if(!cell) return;
                let datafield = cell.datafield;
                let row = cell.rowindex;
                let last_row = this.getvalori().length - 1;

                if (key == 9 && row == last_row && datafield == "pezzi_collo" && !event.shiftKey) {
                    document.getElementById("buttonContainer4").click();
                    row++;
                    this.$refs.myGridDetails.selectcell(row, 'articolo_id');
                    // this.$refs.myGridDetails.begincelledit(row, 'articolo_id');
                    return true;
                } else if (key == 9 && row < last_row && datafield == "pezzi_collo" && !event.shiftKey) {
                    row++;
                    this.$refs.myGridDetails.selectcell(row, 'articolo_id');
                    // this.$refs.myGridDetails.begincelledit(row, 'articolo_id');
                    return true;
                } else if (key == 9 && row > 0 && datafield == "articolo_id" && event.shiftKey) {
                    row--;
                    this.$refs.myGridDetails.selectcell(row, 'pezzi_collo');
                    // this.$refs.myGridDetails.begincelledit(row, 'lotto');
                    return true;
                }
                //navigazione generica
                else if (key == 9 && !event.shiftKey) {
                    if(this.crudmodel.indexOf("GestioneUsciteCorpo") !== -1){
                        switch(datafield){
                            case "articolo_id":
                                this.$refs.myGridDetails.endcelledit(row, 'articolo_id', false);
                                this.$refs.myGridDetails.selectcell(row, 'descrizione_articolo_id');
                                // this.$refs.myGridDetails.begincelledit(row, 'quantita_caricata');
                                return true;
                            case "descrizione_articolo_id":
                                this.$refs.myGridDetails.endcelledit(row, 'descrizione_articolo_id', false);
                                this.$refs.myGridDetails.selectcell(row, 'quantita_caricata');
                                // this.$refs.myGridDetails.begincelledit(row, 'quantita_caricata');
                                return true;
                            case "quantita_caricata":
                                this.$refs.myGridDetails.endcelledit(row, 'quantita_caricata', false);
                                this.$refs.myGridDetails.selectcell(row, 'lotto');
                                // this.$refs.myGridDetails.begincelledit(row, 'quantita_caricata');
                                return true;
                            case "lotto":
                                this.$refs.myGridDetails.endcelledit(row, 'lotto', false);
                                this.$refs.myGridDetails.selectcell(row, 'pezzi_collo');
                                // this.$refs.myGridDetails.begincelledit(row, 'quantita_caricata');
                                return true;
                        }
                    } else {
                        switch(datafield){
                            case "articolo_id":
                                this.$refs.myGridDetails.endcelledit(row, 'articolo_id', false);
                                this.$refs.myGridDetails.selectcell(row, 'descrizione_articolo_id');
                                // this.$refs.myGridDetails.begincelledit(row, 'quantita_caricata');
                                return true;
                            case "descrizione_articolo_id":
                                this.$refs.myGridDetails.endcelledit(row, 'descrizione_articolo_id', false);
                                this.$refs.myGridDetails.selectcell(row, 'quantita_dichiarata');
                                // this.$refs.myGridDetails.begincelledit(row, 'quantita_dichiarata');
                                return true;
                            case "quantita_dichiarata":
                                this.$refs.myGridDetails.endcelledit(row, 'quantita_dichiarata', false);
                                this.$refs.myGridDetails.selectcell(row, 'lotto');
                                // this.$refs.myGridDetails.begincelledit(row, 'quantita_caricata');
                                return true;
                            case "lotto":
                                this.$refs.myGridDetails.endcelledit(row, 'lotto', false);
                                this.$refs.myGridDetails.selectcell(row, 'posti_pallet');
                                // this.$refs.myGridDetails.begincelledit(row, 'quantita_caricata');
                                return true;
                            case "posti_pallet":
                                this.$refs.myGridDetails.endcelledit(row, 'posti_pallet', false);
                                this.$refs.myGridDetails.selectcell(row, 'pezzi_collo');
                                // this.$refs.myGridDetails.begincelledit(row, 'quantita_caricata');
                                return true;
                        }
                    }
                } else if (key == 9 && event.shiftKey) {
                    if(this.crudmodel.indexOf("GestioneUsciteCorpo") !== -1){
                        switch(datafield){
                            case "descrizione_articolo_id":
                                this.$refs.myGridDetails.endcelledit(row, 'descrizione_articolo_id', false);
                                this.$refs.myGridDetails.selectcell(row, 'articolo_id');
                                // this.$refs.myGridDetails.begincelledit(row, 'descrizione_articolo_id');
                                return true;
                            case "lotto":
                                this.$refs.myGridDetails.endcelledit(row, 'lotto', false);
                                this.$refs.myGridDetails.selectcell(row, 'quantita_caricata');
                                // this.$refs.myGridDetails.begincelledit(row, 'descrizione_articolo_id');
                                return true;
                            case "quantita_caricata":
                                this.$refs.myGridDetails.endcelledit(row, 'quantita_caricata', false);
                                this.$refs.myGridDetails.selectcell(row, 'descrizione_articolo_id');
                                // this.$refs.myGridDetails.begincelledit(row, 'descrizione_articolo_id');
                                return true;
                            case "pezzi_collo":
                                this.$refs.myGridDetails.endcelledit(row, 'pezzi_collo', false);
                                this.$refs.myGridDetails.selectcell(row, 'lotto');
                                return true;
                        }
                    } else {
                        switch(datafield){
                            case "descrizione_articolo_id":
                                this.$refs.myGridDetails.endcelledit(row, 'descrizione_articolo_id', false);
                                this.$refs.myGridDetails.selectcell(row, 'articolo_id');
                                // this.$refs.myGridDetails.begincelledit(row, 'descrizione_articolo_id');
                                return true;
                            case "lotto":
                                this.$refs.myGridDetails.endcelledit(row, 'lotto', false);
                                this.$refs.myGridDetails.selectcell(row, 'quantita_dichiarata');
                                // this.$refs.myGridDetails.begincelledit(row, 'descrizione_articolo_id');
                                return true;
                            case "quantita_dichiarata":
                                this.$refs.myGridDetails.endcelledit(row, 'quantita_dichiarata', false);
                                this.$refs.myGridDetails.selectcell(row, 'descrizione_articolo_id');
                                // this.$refs.myGridDetails.begincelledit(row, 'descrizione_articolo_id');
                                return true;
                            case "pezzi_collo":
                                this.$refs.myGridDetails.endcelledit(row, 'pezzi_collo', false);
                                this.$refs.myGridDetails.selectcell(row, 'posti_pallet');
                                return true;
                            case "posti_pallet":
                                this.$refs.myGridDetails.endcelledit(row, 'posti_pallet', false);
                                this.$refs.myGridDetails.selectcell(row, 'lotto');
                                // this.$refs.myGridDetails.begincelledit(row, 'descrizione_articolo_id');
                                return true;
                        }
                    }
                }
                return false;
            },
            endEdit: function () {
                let cell = this.$refs.myGridDetails.getselectedcell();
                try {
                    if (cell) {
                        let rowBoundIndex = cell.rowindex;
                        let column = cell.column;
                        this.$refs.myGridDetails.endcelledit(rowBoundIndex, column, false);
                    }
                } catch (error) {
                    //console.log(error);
                }

            }
        }
    }
</script>

<style scoped>
    .jqx-splitter {
        border: none;
    }

</style>


